var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"photos-top-wrapper"},[_c('div',{staticClass:"photos-left"},[_c('router-link',{staticClass:"m-0",attrs:{"to":"/profile"}},[_c('img',{attrs:{"src":require("../../assets/images/arrow-left.png"),"alt":""}})]),_c('h3',[_vm._v("Photos")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }